export { default } from './TabScrollButton';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/TabScrollButton/index.js
// module id = 189
// module chunks = 0